<template>
  <div id="index" ref="appRef">
    <div class="large-screen-box">
      <div class="header-box">
        <div class="time-box">
          <img src="@/assets/screen/clock.png" alt="" />
          {{nowTime}}
        </div>
        <div class="frame">
          <img src="@/assets/screen/frame.png" alt="" />
          杜一生数据统计
        </div>
      </div>
      <div class="main-content">
        <el-row :gutter="20">
          <el-col :span="8" class="grid-left">
            <div class="left-box1" v-if="collectionData">
              <div class="statis-title">
                <img class="img1" src="@/assets/screen/userdata.png" alt="" />
                <span>收款统计</span>
                <img class="hint" src="@/assets/screen/hint.png" alt="" />
              </div>
              <div class="statis-box">
                <div>
                  <p>今年收款</p>
                  <p>{{collectionData.thisYear}}元
                    <span :class="{'green': collectionData.yearPercent < 0}">{{Math.abs(collectionData.yearPercent)}}%</span>
                    <img src="@/assets/screen/up1.png" alt="" v-if="collectionData.yearPercent > 0" />
                    <img src="@/assets/screen/up.png" alt="" v-if="collectionData.yearPercent < 0" />
                  </p>
                </div>
                <div>
                  <p>今日总收款</p>
                  <p>{{collectionData.thisDay}}元
                    <span :class="{'green': collectionData.dayPercent < 0}">{{Math.abs(collectionData.dayPercent)}}%</span>
                    <img src="@/assets/screen/up1.png" alt="" v-if="collectionData.dayPercent > 0" />
                    <img src="@/assets/screen/up.png" alt="" v-if="collectionData.dayPercent < 0" />
                  </p>
                </div>
                <div>
                  <p>本周收款</p>
                  <p>{{collectionData.thisWeek}}元
                    <span :class="{'green': collectionData.weekPercent < 0}">{{Math.abs(collectionData.weekPercent)}}%</span>
                    <img src="@/assets/screen/up1.png" alt="" v-if="collectionData.weekPercent > 0" />
                    <img src="@/assets/screen/up.png" alt="" v-if="collectionData.weekPercent < 0" />
                  </p>
                </div>
                <div>
                  <p>本月收款</p>
                  <p>{{collectionData.thisMoon}}元
                    <span :class="{'green': collectionData.moonPercent < 0}">{{Math.abs(collectionData.moonPercent)}}%</span>
                    <img src="@/assets/screen/up1.png" alt="" v-if="collectionData.moonPercent > 0" />
                    <img src="@/assets/screen/up.png" alt="" v-if="collectionData.moonPercent < 0" />
                  </p>
                </div>
              </div>
            </div>
            <div class="left-box2">
              <customer-vue :customerData="customerData" />
            </div>
            <div class="left-box3">
              <div class="statis-title">
                <img class="img1" src="@/assets/screen/people.png" alt="" />
                <span>客户类型</span>
              </div>
              <div class="customer-type" v-if="customerClassData">
                <div v-for="(item,index) in customerClassData" :key="index">
                  <img src="@/assets/screen/user2.png" alt="" v-if="index === 1" />
                  <img src="@/assets/screen/user3.png" alt="" v-else-if="index === 2" />
                  <img src="@/assets/screen/user1.png" alt="" v-else />
                  <p>{{item.count}}人<br /><span>{{item.value}}客户</span></p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="grid-center">
            <div class="center-box1">
              <statistics-vue :type="1" :allStatistics="allStatistics" :analysis="analysis" />
            </div>
            <div class="center-box2">
              <div class="center-box2-left" v-if="customerData">
                <div class="statis-title">
                  <img class="img1" src="@/assets/screen/people.png" alt="" />
                  <span>APP新老客户</span>
                </div>
                <div class="statis-data">
                  <div>新客户(人)<br /><span>{{customerData.newCustomerCou}}</span></div>
                  <div>老客户(人)<br /><span>{{customerData.oldCustomerCou}}</span></div>
                </div>
              </div>
              <div class="center-box2-right">
                <div class="statis-title">
                  <img class="img1" src="@/assets/screen/people.png" alt="" />
                  <span>小程序新老客户</span>
                </div>
                <div class="statis-data">
                  <div>新客户(人)<br /><span>0</span></div>
                  <div>老客户(人)<br /><span>0</span></div>
                </div>
              </div>
            </div>
            <div class="center-box3">
              <div class="center-box3-left" v-if="productRank">
                <div class="statis-title">
                  <img class="img1" src="@/assets/screen/jing.png" alt="" />
                  <span>商品排名</span>
                </div>
                <div class="sales-volume">
                  <div>
                    今日总销量<br />
                    <span>{{productRank.nowCount}}</span>
                    <p>
                      较昨日增加
                      <span :class="{'green': +productRank.growthRatio < 0}">{{Math.abs(productRank.growthRatio)}}%</span>
                      <img src="@/assets/screen/up1.png" alt="" v-if="+productRank.growthRatio > 0" />
                      <img src="@/assets/screen/up.png" alt="" v-if="+productRank.growthRatio < 0" />
                    </p>
                  </div>
                </div>
                <div class="product-box">
                  <div class="prod-head"><span>产品名称</span><span>销量</span></div>
                  <vue-seamless-scroll :data="productRank.goodsRanking" class="seamless-warp" style="height: 115px" :class-option="classOption">
                    <div class="prod-main">
                      <div v-for="(item,index) in productRank.goodsRanking" :key="index">
                        <p>{{item.goodsName}}</p><span>{{item.salesVolume}}</span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                </div>
              </div>
              <div class="center-box3-right">
                <div class="statis-title">
                  <img class="img1" src="@/assets/screen/jing.png" alt="" />
                  <span>线下会议统计</span>
                </div>
                <div class="sales-volume-right">
                  <div>总会议(场)<br /><span>{{meetingData && meetingData.sumNum}}</span></div>
                </div>
                <div class="sign-up">
                  <div>总报名(人)<br />{{meetingData && meetingData.sumSignUp}}</div>
                  <div>总签到(人)<br />{{meetingData && meetingData.sumSignIn}}</div>
                </div>
                <div class="meeting-box">
                  <div class="meet-head">
                    <p>会议名称</p><span>报名(人)</span><span>签到(人)</span>
                  </div>
                  <vue-seamless-scroll :data="meetingList" class="seamless-warp" style="height: 86px" :class-option="classOption">
                    <div class="meet-main">
                      <div v-for="(item,index) in meetingList" :key="index">
                        <p>{{item.title}}</p><span>{{item.sumSignUp}}</span><span>{{item.sumSignIn}}</span>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="grid-right">
            <div class="right-box1">
              <statistics-vue :type="2" :allStatistics="allStatistics" />
            </div>
            <div class="right-box2">
              <cake-shaped-vue />
            </div>
            <div class="right-box3">
              <salesperson-vue :customerData="customerData" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import homeStatisticsApi from '@/api/home'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import customerClassifyApi from '@/api/config/customerClassify'
import CakeShapedVue from './screenCommon/cakeShaped.vue'
import drawMixin from "@/utils/drawMixin"; //自适应缩放
import CustomerVue from './screenCommon/customer.vue';
import StatisticsVue from './screenCommon/statistics.vue';
import salespersonVue from './screenCommon/salesperson.vue';
import { Subtr, accMul, isYearCross, isToday, isSameWeek, isSameMonth, dealLessTen, getMonthDates } from '@/utils/index'
export default {
  mixins: [drawMixin],
  components: { CakeShapedVue, CustomerVue, StatisticsVue, salespersonVue },
  data() {
    return {
      productRank: null,
      meetingData: null,
      meetingList: [],
      collectionData: null, //收款统计
      nowTime: '',
      customerData: {},
      customerClass: null,  //客户类型
      allStatistics: null,
      analysis: []
    }
  },
  created() {
    this.getProductRank()
    this.getMeetingData()
    this.getScreenPay()
    this.getCustomer()
    this.getCustomerClass()
    this.getfindMoneyTotalByDate()
  },
  mounted() {
    this.nowTimes()
  },
  beforeDestroy() {
    this.clear()
  },
  methods: {
    getfindMoneyTotalByDate() {
      let arrDate = getMonthDates()
      let parmas = {
        startTime: arrDate[0],
        endTime: arrDate[1],
        timeType: 3
      }
      homeStatisticsApi.complianceStandardsK(parmas).then(({ data }) => {
        if (data.length > 0) {
          this.allStatistics = data[0]
        }
      })
    },
    getCustomer() {
      homeStatisticsApi.screenCustomer().then(res => {
        this.customerData = res.data
      })
    },
    getCustomerClass() {
      customerClassifyApi.findOptions().then(res => {
        this.customerClass = res.data.reverse()
      })
    },
    //收款统计
    getScreenPay() {
      homeStatisticsApi.screenPay().then(res => {
        let { screenPayVOList, analysis } = res.data
        this.analysis = analysis
        // 1日2周3月4季度5年
        // （今天-昨天）/昨天*100%
        //判断年 
        let thisY = screenPayVOList.find(item => item.timeType === 5 && isYearCross(item.startTime))
        let lastY = screenPayVOList.find(item => item.timeType === 5 && !isYearCross(item.startTime))
        //判断日
        let thisD = screenPayVOList.find(item => item.timeType === 1 && isToday(item.startTime))
        let lastD = screenPayVOList.find(item => item.timeType === 1 && !isToday(item.startTime))
        //判断周
        let thisW = screenPayVOList.find(item => item.timeType === 2 && isSameWeek(item.startTime))
        let lastW = screenPayVOList.find(item => item.timeType === 2 && !isSameWeek(item.startTime))
        //判断月
        let thisM = screenPayVOList.find(item => item.timeType === 3 && isSameMonth(item.startTime))
        let lastM = screenPayVOList.find(item => item.timeType === 3 && !isSameMonth(item.startTime))
        let obj = {
          thisYear: thisY.money,
          lastYear: lastY.money,
          yearPercent: lastY.money ? (Subtr(thisY.money, lastY.money) / lastY.money * 100).toFixed(2) : (thisY.money ? 100 : 0),
          thisDay: thisD.money,
          lastDay: lastD.money,
          dayPercent: lastD.money ? (Subtr(thisD.money, lastD.money) / lastD.money * 100).toFixed(2) : (thisD.money ? 100 : 0),
          thisWeek: thisW.money,
          lastWeek: lastW.money,
          weekPercent: lastW.money ? (Subtr(thisW.money, lastW.money) / lastW.money * 100).toFixed(2) : (thisW.money ? 100 : 0),
          thisMoon: thisM.money,
          lastMoon: lastM.money,
          moonPercent: lastM.money ? (Subtr(thisM.money, lastM.money) / lastM.money * 100).toFixed(2) : (thisM.money ? 100 : 0)
        }
        this.collectionData = obj;
      })
    },
    // 商品排名
    getProductRank() {
      homeStatisticsApi.sysGoodsRanking().then(res => {
        let { nowCount, yesterdayCount } = res.data;
        let ratio = yesterdayCount ? (Subtr(nowCount, yesterdayCount) / yesterdayCount * 100) : 100;
        res.data.growthRatio = ratio
        this.productRank = res.data
      })
    },
    //线下会议统计
    getMeetingData() {
      DataBoardApi.findMeetStatisticsByBigScreen().then(res => {
        this.meetingData = res.data
      })
      DataBoardApi.findMeetStatisticsDownList().then(res => {
        this.meetingList = res.data || []
      })
    },
    //获取当前时间
    timeNow(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      this.nowTime = year + "-" + month + "-" + date + " " + hh + ":" + mm;
    },
    // 实时刷新当前时间，格式化
    nowTimes() {
      this.timeNow(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear()
    },
    //清除定时器
    clear() {
      clearInterval(this.nowTimes)
      this.nowTimes = null;
    },
  },
  computed: {
    customerClassData() {
      let list = this.customerClass;
      let { screenCustomerClassify } = this.customerData;
      if (!screenCustomerClassify) return
      list && list.forEach(item => {
        let find = screenCustomerClassify.find(itt => itt.keyLong1 === item.key);
        if (find) item.count = find.valueLong1
      });
      return list
    },
    classOption() {
      return {
        step: 0.3, //滚动的速度
        limitMoveNum: 3, //开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, //鼠标悬停，true/false
        direction: 1, //滚动的方向，0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom，true/false
        singleHeight: 0, //滚动多少高度停留一次
        singleWidth: 0, //无缝不停止的滚动
        waitTime: 1000 //单步运动停止的时间(默认值1000ms)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin modular($hig, $mbt) {
  height: $hig;
  margin-bottom: $mbt;
  padding: 16px;
  box-sizing: border-box;
  background: #14142b;
  border-radius: 8px;
}
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}
@mixin fontColor($fonsSize, $color) {
  font-size: $fonsSize;
  color: $color;
}
#index {
  color: #d3d6dd;
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow: hidden;
  .large-screen-box {
    //整体页面背景
    width: 100%;
    height: 100%;
    background-size: cover; //背景尺寸
    background-position: center center; //背景位置
    background-color: #05050f;
    .header-box {
      font-size: 24px;
      background-color: #14142b;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .time-box {
        color: #9292c1;
        position: absolute;
        left: 20px;
        img {
          @include wh(24px, 24px);
          position: relative;
          top: 2px;
        }
      }
      .frame {
        color: #fff;
        font-weight: bold;
        display: flex;
        align-items: center;
        img {
          @include wh(40px, 40px);
          margin-right: 8px;
        }
      }
    }
    .main-content {
      padding: 20px;
      .statis-title {
        display: flex;
        align-items: center;
        span {
          @include fontColor(16px, #fff);
          padding: 0 10px 0 8px;
        }
        .img1 {
          @include wh(24px, 24px);
        }
        .hint {
          @include wh(13px, 13px);
          cursor: pointer;
        }
      }
      .grid-left {
        .left-box1 {
          @include modular(267px, 16px);

          .statis-box {
            margin-top: 16px;
            div {
              width: 48%;
              margin-bottom: 42px;
              display: inline-block;
              line-height: 30px;
              padding-left: 30px;
              p {
                @include fontColor(24px, #fff);
                margin: 0;
                span {
                  @include fontColor(12px, #e73f3f);
                  &.green {
                    color: #5eff5a;
                  }
                }
                img {
                  @include wh(14px, 14px);
                  position: relative;
                  top: 3px;
                }
              }
            }
          }
        }
        .left-box2 {
          @include modular(390px, 16px);
        }
        .left-box3 {
          @include modular(287px, 0);
          .customer-type {
            margin-top: 47px;
            div {
              width: 48%;
              display: inline-block;
              margin-bottom: 42px;
              img {
                @include wh(48px, 48px);
                margin-right: 8px;
              }
              p {
                display: inline-block;
                margin: 0;
                line-height: 28px;
                @include fontColor(16px, #fff);
                span {
                  font-size: 24px;
                }
              }
            }
          }
        }
      }
      .grid-center {
        .center-box1 {
          @include modular(390px, 16px);
        }
        .center-box2 {
          display: flex;
          .center-box2-left {
            width: 300px;
            margin-right: 16px;
            @include modular(201px, 16px);
          }
          .center-box2-right {
            width: 300px;
            @include modular(201px, 16px);
          }
          .statis-data {
            display: flex;
            align-items: center;
            margin-top: 32px;
            div {
              width: 50%;
              line-height: 40px;
              @include fontColor(18px, #fff);
              span {
                font-size: 40px;
              }
            }
          }
        }
        .center-box3 {
          display: flex;
          .center-box3-left {
            width: 300px;
            margin-right: 16px;
            @include modular(355px, 0);
            .sales-volume {
              margin-top: 32px;
              div {
                @include fontColor(18px, #fff);
                span {
                  font-size: 48px;
                }
                p {
                  margin: 0;
                  @include fontColor(12px, #9292c1);
                  span {
                    font-size: 12px;
                  }
                  .green {
                    @include fontColor(12px, #5eff5a);
                  }
                  img {
                    @include wh(14px, 14px);
                    position: relative;
                    top: 3px;
                  }
                }
              }
            }
          }
          .center-box3-right {
            width: 300px;
            @include modular(355px, 0);
            .sales-volume-right {
              margin-top: 24px;
              div {
                @include fontColor(18px, #fff);
                span {
                  font-size: 48px;
                }
              }
            }
            .sign-up {
              @include fontColor(18px, #fff);
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 10px;
              div {
                line-height: 28px;
              }
            }
          }
        }
      }
      .grid-right {
        .right-box1 {
          @include modular(390px, 16px);
        }
        .right-box2 {
          @include modular(260px, 16px);
        }
        .right-box3 {
          @include modular(296px, 0);
        }
      }
    }
  }
}
.product-box {
  margin-top: 30px;
  .prod-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    span {
      @include fontColor(14px, #fff);
    }
  }
  .prod-main {
    margin-bottom: 2px;
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      @include fontColor(14px, #fff);
      p {
        margin: 0;
        width: 60%;
        background: linear-gradient(to left, #7517f8, #e122fe);
        padding: 3px 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        width: 40%;
        display: inline-block;
        text-align: right;
      }
    }
  }
}
.meeting-box {
  margin-top: 24px;
  .meet-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include fontColor(14px, #fff);
    margin-bottom: 10px;
    p {
      width: 60%;
      margin: 0;
    }
    span {
      width: 20%;
      display: inline-block;
      text-align: right;
    }
  }
  .meet-main {
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      @include fontColor(14px, #fff);
      p {
        width: 60%;
        overflow: hidden;
        background: linear-gradient(to left, #7517f8, #e122fe);
        padding: 3px 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0;
      }
      span {
        width: 20%;
        display: inline-block;
        text-align: right;
      }
    }
  }
}
.seamless-warp {
  overflow: hidden;
}
</style>
